// extracted by css-extract-rspack-plugin
export default {"actionIconBookmarked":"rUYwN","icon":"ASAwE","iconAnimating":"bVH07","iconAnimatingBookmarked":"r1N1a","expand":"VnxIW","iconAnimatingUnbookmarked":"SLfEh","shrink":"ndCD2"};